import * as React from 'react'
import styled from 'styled-components'

import ActionButton from '../../../../components/ui/ActionButton/ActionButton'

const ButtonWrapper = styled.form`
  margin: 1rem 0 0;
`

const BlockButton = styled(ActionButton)`
  width: 100%;
  border-color: transparent;
  font-weight: var(--font-weight-bold);
`

function SkipAddAvatarForm(props) {
  const { handleSubmit } = props

  return (
    <ButtonWrapper onSubmit={handleSubmit}>
      <BlockButton type="submit" data-testid="skipAddAvatarButton">
        Maybe Later
      </BlockButton>
    </ButtonWrapper>
  )
}

SkipAddAvatarForm.defaultProps = {
  // TODO: specify default props
}

SkipAddAvatarForm.propTypes = {
  // TODO: specify prop types
}

export default SkipAddAvatarForm
